import styled from '@emotion/styled/macro';

export const Content = styled.div`
  padding: 15px 0;
`;
